import { defineMessage } from 'services/localization';

export const messages = {
    ifTextApprovalMatrix: defineMessage('should_approve_if'),
    ifTextReviewerMatrix: defineMessage('should_review_if'),
    ifTextEditorMatrix: defineMessage('can_set'),
    ifTextRequesterMatrix: defineMessage('can_submit_with'),
    ifTextEditingMatrix: defineMessage('can_edit_with'),
    orTextApprovalMatrix: defineMessage('or_if'),
    orTextReviewerMatrix: defineMessage('or_if'),
    orTextEditorMatrix: defineMessage('or_with'),
    orTextRequesterMatrix: defineMessage('or_with'),
    removeUserTextApprovalMatrix: defineMessage('remove_an_approver_from_the_step'),
    removeUserTextEditorMatrix: defineMessage('remove_a_reviewer'),
    removeUserTextRequesterMatrix: defineMessage('remove_a_requester'),
    removeUserTitleApprovalMatrix: defineMessage('remove_an_approver_from_the_step'),
    removeUserTitleEditorMatrix: defineMessage('remove_a_reviewer_from_this_step'),
    removeUserTitleRequesterMatrix: defineMessage('remove_a_requester'),
    invalidConditions: defineMessage('please_ensure_that_all_set_conditions_are_valid'),
};
